
import React from 'react';
import { DialogTitle, IconButton, useTheme, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

interface AssistantHeaderProps {
  onClose: () => void;
}

const AssistantHeader = ({ onClose }: AssistantHeaderProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <DialogTitle sx={{
      borderBottom: 1,
      borderColor: 'divider',
      p: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: isMobile ? 'sticky' : 'static',
      top: 0,
      zIndex: 1,
      bgcolor: 'background.default'
    }}>
      {t('assistant.title')}
      <IconButton onClick={onClose} aria-label="close">
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
};

export default AssistantHeader;
